import { useCallback } from 'react';

import { useQuery } from '../hooks';

import { CMS_TOOLTIPS } from '../../graphql/cms-queries';

function useCmsTooltips(id = '/tool-tips/master') {
  const { data: cmsData } = useQuery(CMS_TOOLTIPS, {
    variables: {
      id
    }
  });

  const { contentSlots } = cmsData?.cms?.page || {};

  const getToolTipById = useCallback(
    id =>
      contentSlots?.[0]?.cmsComponents?.[0]?.tooltips?.find(
        tooltip => tooltip.id === id
      )?.tipText,
    [contentSlots]
  );

  return {
    cmsData,
    getToolTipById
  };
}

export default useCmsTooltips;
